import { Box } from '@mantine/core';
import CompanyWrapper from 'src/company/templates/components/CompanyWrapper';
import { Company } from 'src/secret-menu/hooks/useCompanies';
import TenantApiKeysManager from 'src/admin/dev-tools/TenantApiKeysManager';

export default function TenantApiKeysTab() {
  return <CompanyWrapper contentComponent={TenantApiKeysContent} />;
}

function TenantApiKeysContent({ company }: { company: Company }) {
  return (
    <Box>
      <TenantApiKeysManager companyId={company.id} title="External API keys" />
    </Box>
  );
}
